/**
 * Klucze storage
 *
 * @export
 * @enum {number}
 */
export enum Storage {
  FILTERS = 'filters',
  PROFILE_ID = 'profileId',
  TOKEN = 'token',
  HTML_EDIT = 'html_edit',
  PREVIOUS_FULL_PATH = 'previous_full_path',
  REDIRECT = 'redirect',
  REPORT_COLUMNS = 'report_columns',
  REPORT_FILTERS = 'report_filters',
  REPORT_GROUPS = 'report_groups'
}
